var SERVER_URL = ''

if (process.env.REACT_APP_CUSTOM_NODE_ENV == 'preprod') {
    SERVER_URL = "https://api-preprod.primaonline.app/";
} else if (process.env.NODE_ENV == 'development') {
    SERVER_URL = "https://api-polar.preprod.rmdev.it/";
} else if (process.env.NODE_ENV == 'production') {
    SERVER_URL = "https://api.primaonline.app/";
} else {
    SERVER_URL = "https://localhost:44343/";
}

export { SERVER_URL as default };


// WEBPACK FOOTER //
// ./src/Global.js